import { loadView } from '@/router'

export default [
  {
    path: 'accounts',
    name: 'customerservice-accounts',
    component: loadView('Application/CustomerService/Accounts'),
    redirect: {
      name: 'customerservice-accounts-list'
    },
    showInAlfred: true,
    alfredTitle: 'Customer Service - Accounts',
    children: [
      {
        path: 'list',
        name: 'customerservice-accounts-list',
        component: loadView('Application/CustomerService/Accounts/List')
      },
      {
        path: ':accountId',
        name: 'customerservice-accounts-account',
        component: loadView('Application/CustomerService/Accounts/Account'),
        redirect: {
          name: 'customerservice-accounts-account-dashboard'
        },
        children: [
          {
            path: 'contacts',
            name: 'customerservice-accounts-account-contacts',
            component: loadView('Application/CustomerService/Accounts/Account/Contacts')
          },
          {
            path: 'dashboard',
            name: 'customerservice-accounts-account-dashboard',
            component: loadView('Application/CustomerService/Accounts/Account/Dashboard')
          },
          {
            path: 'details',
            name: 'customerservice-accounts-account-details',
            component: loadView('Application/CustomerService/Accounts/Account/Details')
          },
          {
            path: 'configure',
            name: 'customerservice-accounts-account-configure',
            component: loadView('Application/CustomerService/Accounts/Account/Configure')
          },
          {
            path: 'carriers',
            name: 'customerservice-accounts-account-carriers',
            component: loadView('Application/CustomerService/Accounts/Account/Carriers')
          },
          {
            path: 'histories',
            name: 'customerservice-accounts-account-histories',
            component: loadView('Application/CustomerService/Accounts/Account/Histories')
          },
          {
            path: 'teams',
            name: 'customerservice-accounts-account-teams',
            component: loadView('Application/CustomerService/Accounts/Account/Teams')
          },
          {
            path: 'enquiries',
            name: 'customerservice-accounts-account-enquiries',
            component: loadView('Application/CustomerService/Accounts/Account/Enquiries')
          },
          {
            path: 'notes',
            name: 'customerservice-accounts-account-notes',
            component: loadView('Application/CustomerService/Accounts/Account/Notes')
          },
          {
            path: 'attachments',
            name: 'customerservice-accounts-account-attachments',
            component: loadView('Application/CustomerService/Accounts/Account/Attachments')
          },
          {
            path: 'addresses',
            name: 'customerservice-accounts-account-addresses',
            component: loadView('Application/CustomerService/Accounts/Account/Addresses')
          },
          {
            path: 'locations',
            name: 'customerservice-accounts-account-locations',
            component: loadView('Application/CustomerService/Accounts/Account/Locations')
          },
          {
            path: 'pickups',
            name: 'customerservice-accounts-account-pickups',
            component: loadView('Application/CustomerService/Accounts/Account/Pickups'),
            redirect: {
              name: 'customerservice-accounts-account-pickups-list'
            },
            children: [
              {
                path: 'list',
                name: 'customerservice-accounts-account-pickups-list',
                component: loadView('Application/CustomerService/Accounts/Account/Pickups/List')
              },
              {
                path: ':pickupId',
                name: 'customerservice-accounts-account-pickups-pickup',
                component: loadView('Application/CustomerService/Accounts/Account/Pickups/Pickup'),
                redirect: {
                  name: 'customerservice-accounts-account-pickups-pickup-details'
                },
                children: [
                  {
                    path: 'details',
                    name: 'customerservice-accounts-account-pickups-pickup-details',
                    component: loadView('Application/CustomerService/Accounts/Account/Pickups/Pickup/Details')
                  },
                  {
                    path: 'notes',
                    name: 'customerservice-accounts-account-pickups-pickup-notes',
                    component: loadView('Application/CustomerService/Accounts/Account/Pickups/Pickup/Notes')
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
]
